(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('ctmsService', ctmsService);

    function ctmsService(commonService, isTestMode, $http, apiUrl, enumService, testData, $rootScope, $q, blockUI) {
        var service = {
            MyTrainingPoint: MyTrainingPoint,
            SysTypesList: SysTypesList,
            ActivityTypesUnderClassification: ActivityTypesUnderClassification,
            FCLicenseList: FCLicenseList,
            CourseItem: CourseItem,
            PublishedActivity: PublishedActivity,
            CourseSession: CourseSession,
            ExamSurveyContent: ExamSurveyContent,
            InteractionData: InteractionData,
            MyUnfinishedActivities: MyUnfinishedActivities,
            MyFinishedActivities: MyFinishedActivities,
            EnrollmentAvailableAction: EnrollmentAvailableAction,
            EnrollmentAction: EnrollmentAction,
            FCCertificatedLicenseAdd: FCCertificatedLicenseAdd,
            FCCertificatedLicenseList: FCCertificatedLicenseList,
            FCAuthorizedHoursList: FCAuthorizedHoursList,
            ExternalTrainingApplication: ExternalTrainingApplication,
            FCEnrollableActivities: FCEnrollableActivities,
            LearningRecordCommit: LearningRecordCommit,
            getStampFile: getStampFile,
        };
        return service;
        function MyTrainingPoint(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.MyTrainingPoint(params.Annual);
            }
            else {
                apiResult = callCtmsApi('MyTrainingPoint.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'MyTrainingPoint.do');
                return returnResult;
            });
        }

        function SysTypesList(params) {
            var apiResult;
            // console.log("SysTypesList params:",params);
            if (isTestMode) {
                apiResult = testData.SysTypesList(params.Type);
            }
            else {
                apiResult = callCtmsApi('SysTypesList.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'SysTypesList.do');
                return returnResult;
            });
        }

        function ActivityTypesUnderClassification(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = null;
            }
            else {
                apiResult = callCtmsApi('ActivityTypesUnderClassification.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'ActivityTypesUnderClassification.do');
                return returnResult;
            });
        }

        function FCLicenseList(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.FCLicenseList(params);
            }
            else {
                apiResult = callCtmsApi('FCLicenseList.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'FCLicenseList.do');
                return returnResult;
            });
        }

        function CourseItem(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.CourseItem(params);
            }
            else {
                apiResult = callCtmsApi('CourseItem.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'CourseItem.do');
                return returnResult;
            });
        }

        function PublishedActivity(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.PublishedActivity(params);
            }
            else {
                apiResult = callCtmsApi('PublishedActivity.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'PublishedActivity.do');
                return returnResult;
            });
        }

        function CourseSession(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.CourseSession(params.CourseType);
            }
            else {
                apiResult = callCtmsApi('CourseSession.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'CourseSession.do');
                //console.log('sunnet CourseSession result:',returnResult);
                return returnResult;
            });
        }

        function ExamSurveyContent(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.ExamSurveyContent(params);
            }
            else {
                apiResult = callCtmsApi('ExamSurveyContent.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'ExamSurveyContent.do');
                return returnResult;
            });
        }

        function InteractionData(params) {
            blockUI.start();
            var apiResult;
            if (isTestMode) {
                apiResult = testData.InteractionData(params);
            }
            else {
                apiResult = callCtmsApi('InteractionData.do', params);
                // apiResult = $http.post(apiUrl.tsApi+'ctms/InteractionData', params);
            }
            return $q.when(apiResult).then(function (data) {
                blockUI.stop();
                var returnResult = ctmsResultFormat(data, 'InteractionData.do');
                return returnResult;
            });
        }

        function MyUnfinishedActivities(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.MyUnfinishedActivities(params);
            }
            else {
                apiResult = callCtmsApi('MyUnfinishedActivities.do', params);
            }
            return $q.when(apiResult).then(function (data) {

                var returnResult = ctmsResultFormat(data, 'MyUnfinishedActivities.do');
                return returnResult;
            });
        }

        function MyFinishedActivities(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.MyFinishedActivities(params);
            }
            else {
                apiResult = callCtmsApi('MyFinishedActivities.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'MyFinishedActivities.do');
                return returnResult;
            });
        }

        function EnrollmentAvailableAction(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.EnrollmentAvailableAction(params);
            }
            else {
                apiResult = callCtmsApi('EnrollmentAvailableAction.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'EnrollmentAvailableAction.do');
                return returnResult;
            });
        }

        function EnrollmentAction(params) {

            // 測試錯誤情況
            // params.IsProgram = 1;

            // Block the user interface
            blockUI.start();

            var apiResult;
            if (isTestMode) {
                apiResult = testData.EnrollmentAction(params);
            }
            else {
                apiResult = callCtmsApi('EnrollmentAction.do', params);
            }
            return $q.when(apiResult).then(function (data) {

                // Unblock the user interface
                blockUI.stop();

                // console.log('####################')
                // console.log(data)
                var returnResult = ctmsResultFormat(data, 'EnrollmentAction.do');
                if (typeof (returnResult.success) !== 'undefined' && !returnResult.success) {
                    //代表動作失敗
                    //var errorMsg = returnResult.failMessage || '';
                    var errorMsg = '';
                    var errorCode = returnResult.failCode || '0';
                    errorCode = errorCode + '';
                    switch (errorCode) {
                        case '0':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll0;
                            break;
                        case '1':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll1;
                            break;
                        case '2':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll2;
                            break;
                        case '3':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll3;
                            break;
                        case '4':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll4;
                            break;
                        case '5':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll5;
                            break;
                        case '6':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll6;
                            break;
                        case '7':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll7;
                            break;
                        case '8':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll8;
                            break;
                        default:
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll0;
                            break;
                    }
                    toastr.warning($rootScope.translate.tsunSendError + ":" + errorMsg);
                    //==
                    return false;
                }
                return returnResult;
            });
        }

        function FCCertificatedLicenseAdd(params) {
            blockUI.start();
            var apiResult;
            if (isTestMode) {
                apiResult = testData.FCCertificatedLicenseAdd(params);
            }
            else {
                apiResult = callCtmsApi('FCCertificatedLicenseAdd.do', params);
                // apiResult = $http.post(apiUrl.tsApi+'ctms/FinacialLicienceApply', params);
            }
            return $q.when(apiResult).then(function (data) {
                blockUI.stop();
                var returnResult = ctmsResultFormat(data, 'FCCertificatedLicenseAdd.do');
                // console.log('FCCertificatedLicenseAdd returnResult:',returnResult);
                return returnResult;
            });
        }

        function FCCertificatedLicenseList(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.FCCertificatedLicenseList(params);
            }
            else {
                apiResult = callCtmsApi('FCCertificatedLicenseList.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'FCCertificatedLicenseList.do');
                return returnResult;
            });
        }

        function FCAuthorizedHoursList(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.FCAuthorizedHoursList(params);
            }
            else {
                apiResult = callCtmsApi('FCAuthorizedHoursList.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'FCAuthorizedHoursList.do');
                return returnResult;
            });
        }

        function ExternalTrainingApplication(params) {
            blockUI.start();
            var apiResult;
            if (isTestMode) {
                apiResult = testData.ExternalTrainingApplication(params);
            }
            else {
                apiResult = callCtmsApi('ExternalTrainingApplication.do', params);
                // apiResult = $http.post(apiUrl.tsApi+'ctms/ExternalCourseApply', params);
            }
            return $q.when(apiResult).then(function (data) {
                blockUI.stop();
                var returnResult = ctmsResultFormat(data, 'ExternalTrainingApplication.do');
                // console.log("ExternalTrainingApplication return data:",returnResult);
                //=========
                var isSuccess = (returnResult.failCode + '' === '-1'); 
                if (isSuccess === false) {
                    var errorMsg = '';
                    var errorCode = returnResult.failCode || '0';
                    errorCode = errorCode + '';
                    switch (errorCode) {
                        case '0':
                            errorMsg += $rootScope.translate.tsunErrorExternalApplication0;
                            break;
                        case '1':
                            errorMsg += $rootScope.translate.tsunErrorExternalApplication1;
                            break;
                        case '2':
                            errorMsg += $rootScope.translate.tsunErrorExternalApplication2;
                            break;
                        case '3':
                            errorMsg += $rootScope.translate.tsunErrorExternalApplication3;
                            break;
                    }
                    toastr.warning($rootScope.translate.tsunSendError + ":" + errorMsg);
                }
                return isSuccess;
            });
        }

        function FCEnrollableActivities(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.FCEnrollableActivities(params);
            }
            else {
                apiResult = callCtmsApi('FCEnrollableActivities.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'FCEnrollableActivities.do');
                return returnResult;
            });
        }
        function LearningRecordCommit(params) {

            // chris: log for mobile
            //postException(`ctms-learning-record: ${JSON.stringify(params)}`, apiUrl)

            console.log('LearningRecordCommit param:',params);
            var apiResult;
            if (isTestMode) {
                apiResult = testData.LearningRecordCommit(params);
            }
            else {
                apiResult = callCtmsApi('LearningRecordCommit.do', params);
            }
            
            //console.log('LearningRecordCommit Result:',apiResult);
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'LearningRecordCommit.do');
                return returnResult;
            });
        }
        function callCtmsApi(action, params) {
            var actionUrl = apiUrl.ctmsApi + action;
            return $http.post(actionUrl, params, {
                headers: { 'Content-Type': 'application/json' },
            });
        }

        function ctmsResultFormat(result, apiAction) {
            var resultData = result.data;
            var returnResult = null;
            switch (resultData.Status + '') {
                case '200':
                    if(resultData.ErrorMessage){
                        toastr.warning(resultData.ErrorMessage);
                    }else{
                        returnResult = resultData.Data || {};
                    }
                    //console.log('returnResult 200 :',resultData.Data);
                    break;
                case '400':
                    // toastr.warning($rootScope.translate.tsunSendError + "Api[" + apiAction + "]," + resultData.ErrorMessage);
                    toastr.warning($rootScope.translate.tsunSendError + ':' + resultData.ErrorMessage);
                    returnResult = false;
                    break;
                default:
                    apiAction = apiAction || '';
                    var errorLog = " Error,call sunNet Api[" + apiAction + "], msg:" + resultData.ErrorMessage;
                    postException(errorLog, apiUrl);
                    showSystemError();
                    returnResult = false;
                    break;
            }
            //console.log('returnResult:',returnResult);
            return returnResult;
        }

        function getStampFile(attachmentPath, attachmentName) {
			
			
            console.log('getStampFile apiUrl:', apiUrl.tsApi + 'ctms/DownloadPdf');
            console.log('getStampFile token:', sessionStorage.getItem('token'));
            console.log('getStampFile SysCode:', 'MHR');
            console.log('getStampFile attachmentPath:', attachmentPath.replace(".pdf", ""));
            console.log('getStampFile attachmentName', attachmentName);
            console.log('getStampFile attachmentPath:', attachmentPath.replace("/", "_").replace("\\", "_").replace(".pdf", ""));

            return format('{0}/{1}/{2}/{3}/{4}',
                apiUrl.tsApi + 'ctms/DownloadPdf', sessionStorage.getItem('token'), "MHR", attachmentPath.replaceAll("/", "_").replaceAll("\\", "_").replace(".pdf", ""), attachmentName);
            
        }
    }
})();
